
<template>
    <v-dialog v-model="dialog"  persistent max-width="420">
        <v-card>
            <v-card-title style="color:#1565c0"  class="headline">{{title}}</v-card-title>
            <v-card-text> 
            <v-container fluid style="margin-top:-20px">
                <v-layout row wrap >
                <v-flex xs12 sm12 md12>
                    <v-btn dark class="blue darken-2" v-on:click="downloadCredentials()"><v-icon color="amber" style="margin-right:3px">attachment</v-icon> Download</v-btn>
                </v-flex>
                </v-layout>
                <v-layout row wrap >
                <v-flex xs12 sm12 md12>
                    <v-checkbox
                        v-model="downloaded"
                        color="success"
                        value="success"
                        hide-details
                    >
                        <template v-slot:label>
                        <span class="body-1" style="margin-top:5px">I confirm that I have downloaded the target file</span>
                        </template>                  
                    </v-checkbox>
                </v-flex>
                </v-layout>
            </v-container>
            </v-card-text>
            <v-card-actions style="margin-top:-2em">
                <v-spacer></v-spacer>
                <v-btn color="blue darken-2" :disabled="!downloaded" flat @click="$emit('close')">Close</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>  
    export default {
        name: "Downloader",

        props:{
            data: Object,
            title: String
        },

        data(){
            return {
                downloaded: false,
                dialog:true
            }
        },

        methods: {
            downloadCredentials(){
                let saveData = function (data, fileName) {
                    var a = document.createElement("a");
                    document.body.appendChild(a);
                    a.style = "display: none";
                    var 
                        blob = new Blob(data.split(), {type: "octet/stream"}),
                        url = window.URL.createObjectURL(blob);
                        a.href = url;
                        a.download = fileName;
                        a.click();
                        window.URL.revokeObjectURL(url);
                }

                try{
                    if((typeof this.data.data) === 'object'){
                        this.data.data = JSON.stringify(this.data.data);
                    }
                    saveData(this.data.data,this.data.filename+".pem")
                    let fileData = [this.data.data]
                    window.navigator.msSaveOrOpenBlob(new Blob(fileData),this.data.filename+".pem")
                }catch(ex){
                    saveData = null
                }
            }
        }
    }
</script>